var React = require('react');

function SpeakerUrlYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"red","d":"M.40407 13.3096c.3675 1.3035 1.49175 1.542 1.56675 1.5878 1.85025.504 12.22128.5055 14.09928 0 1.2862-.372 1.5225-1.5128 1.5667-1.5878.4898-2.6055.522-6.00222-.0225-8.95872l.0225.147c-.3675-1.3035-1.4917-1.542-1.5667-1.58775-1.8255-.49575-12.22353-.5145-14.09928 0C.68457 3.28288.44832 4.42288.40407 4.49788c-.52425 2.73825-.5505 5.88002 0 8.81172Zm6.8145-1.6672V6.17263l4.69953 2.739-4.69953 2.73077Z"}));
}

SpeakerUrlYoutube.defaultProps = {"fill":"none","viewBox":"0 0 19 18"};

module.exports = SpeakerUrlYoutube;

SpeakerUrlYoutube.default = SpeakerUrlYoutube;
